/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './login.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../shared/svg-icon/svg-icon.component.ngfactory';
import * as i3 from '../../../../app/shared/svg-icon/svg-icon.component';
import * as i4 from '../../../../app/shared/translations/translate.directive';
import * as i5 from '../../../../app/shared/translations/translations.service';
import * as i6 from '../../../../app/shared/settings.service';
import * as i7 from '../../../../app/shared/tooltip/tooltip.component';
import * as i8 from '@angular/common';
import * as i9 from '@angular/router';
import * as i10 from '../../../../app/auth/login/login.component';
import * as i11 from '@angular/forms';
import * as i12 from '../../shared/loading-indicator/loading-indicator.component.ngfactory';
import * as i13 from '../../../../app/shared/loading-indicator/loading-indicator.component';
import * as i14 from '../../../../app/auth/auth.service';
import * as i15 from '../../../../app/shared/http-client';
import * as i16 from '../../../../app/auth/current-user';
import * as i17 from '../../../../app/shared/toast/toast.service';
import * as i18 from '../../../../app/shared/modal/modal.service';
import * as i19 from '../../../../app/auth/social-auth.service';
const styles_LoginComponent:any[] = [i0.styles];
export const RenderType_LoginComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_LoginComponent,data:{}});
function View_LoginComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'general-error']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.errors.general;
    _ck(_v,1,0,currVal_0);
  });
}
function View_LoginComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',[['class',
      'error email-error']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.errors.email;
    _ck(_v,1,0,currVal_0);
  });
}
function View_LoginComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',[['class',
      'error password-error']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.errors.password;
    _ck(_v,1,0,currVal_0);
  });
}
function View_LoginComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),11,'div',[['class',
      'login-with-envato']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),8,'button',[['class','button primary'],
          ['type','button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.socialAuth.loginWith('envato')) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'svg-icon',[['name','envato-custom']],
          (null as any),(null as any),(null as any),i2.View_SvgIconComponent_0,i2.RenderType_SvgIconComponent)),
      i1.ɵdid(114688,(null as any),0,i3.SvgIconComponent,[i1.ElementRef,i1.Renderer2],
          {name:[0,'name']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',[['trans','']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(4341760,
          (null as any),0,i4.TranslateDirective,[i1.ElementRef,i5.Translations,i6.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['Login With Envato'])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n            ']))],(_ck,_v) => {
    const currVal_0:any = 'envato-custom';
    _ck(_v,5,0,currVal_0);
  },(null as any));
}
function View_LoginComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'button',[['class',
      'social-icon no-style facebook'],['tooltip','Login with facebook'],['type','button']],
      (null as any),[[(null as any),'click'],[(null as any),'mouseenter'],[(null as any),
          'mouseleave'],[(null as any),'focusout']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).show($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).hide($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('focusout' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,1).hide($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('click' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,1).hide($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('click' === en)) {
          const pd_4:any = ((<any>_co.socialAuth.loginWith('facebook')) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(147456,(null as any),0,i7.TooltipDirective,
      [i1.Renderer2,i1.ElementRef,i5.Translations],{tooltipText:[0,'tooltipText']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),0,'img',([] as any[]),[[8,'src',4]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
      ['\n                ']))],(_ck,_v) => {
    const currVal_0:any = 'Login with facebook';
    _ck(_v,1,0,currVal_0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = i1.ɵinlineInterpolate(1,'',(_co.settings.get('base_url') + '/assets/images/social-icons/facebook.png'),
        '');
    _ck(_v,3,0,currVal_1);
  });
}
function View_LoginComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'button',[['class',
      'social-icon no-style googleplus'],['tooltip','Login with google'],['type','button']],
      (null as any),[[(null as any),'click'],[(null as any),'mouseenter'],[(null as any),
          'mouseleave'],[(null as any),'focusout']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).show($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).hide($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('focusout' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,1).hide($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('click' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,1).hide($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('click' === en)) {
          const pd_4:any = ((<any>_co.socialAuth.loginWith('google')) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(147456,(null as any),0,i7.TooltipDirective,
      [i1.Renderer2,i1.ElementRef,i5.Translations],{tooltipText:[0,'tooltipText']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),0,'img',([] as any[]),[[8,'src',4]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
      ['\n                ']))],(_ck,_v) => {
    const currVal_0:any = 'Login with google';
    _ck(_v,1,0,currVal_0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = i1.ɵinlineInterpolate(1,'',(_co.settings.get('base_url') + '/assets/images/social-icons/google-plus.png'),
        '');
    _ck(_v,3,0,currVal_1);
  });
}
function View_LoginComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'button',[['class',
      'social-icon no-style twitter'],['tooltip','Login with twitter'],['type','button']],
      (null as any),[[(null as any),'click'],[(null as any),'mouseenter'],[(null as any),
          'mouseleave'],[(null as any),'focusout']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).show($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).hide($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('focusout' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,1).hide($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('click' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,1).hide($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('click' === en)) {
          const pd_4:any = ((<any>_co.socialAuth.loginWith('twitter')) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(147456,(null as any),0,i7.TooltipDirective,
      [i1.Renderer2,i1.ElementRef,i5.Translations],{tooltipText:[0,'tooltipText']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),0,'img',([] as any[]),[[8,'src',4]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
      ['\n                ']))],(_ck,_v) => {
    const currVal_0:any = 'Login with twitter';
    _ck(_v,1,0,currVal_0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = i1.ɵinlineInterpolate(1,'',(_co.settings.get('base_url') + '/assets/images/social-icons/twitter.png'),
        '');
    _ck(_v,3,0,currVal_1);
  });
}
function View_LoginComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'div',[['class',
      'social-icons center']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoginComponent_7)),
      i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoginComponent_8)),
      i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoginComponent_9)),
      i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n            ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.settings.get('social.facebook.enable');
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _co.settings.get('social.google.enable');
        _ck(_v,6,0,currVal_1);
        const currVal_2:any = _co.settings.get('social.twitter.enable');
        _ck(_v,9,0,currVal_2);
      },(null as any));
}
function View_LoginComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),20,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),11,'p',[['class','info-row']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,
          'span',[['trans','']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(4341760,(null as any),0,i4.TranslateDirective,[i1.ElementRef,
          i5.Translations,i6.SettingsService],(null as any),(null as any)),(_l()(),
          i1.ɵted((null as any),['Don\'t have an account?'])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,
          'a',[['class','register-link'],['trans','']],[[1,'target',0],[8,'href',4]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,9).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i9.RouterLinkWithHref,
          [i9.Router,i9.ActivatedRoute,i8.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),i1.ɵdid(4341760,(null as any),0,i4.TranslateDirective,
          [i1.ElementRef,i5.Translations,i6.SettingsService],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['Register here.'])),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵted((null as any),['\n\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoginComponent_5)),
      i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoginComponent_6)),
      i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_2:any = _ck(_v,10,0,'/register');
        _ck(_v,9,0,currVal_2);
        const currVal_3:any = _co.settings.get('envato.enable');
        _ck(_v,16,0,currVal_3);
        const currVal_4:boolean = !_co.settings.get('envato.enable');
        _ck(_v,19,0,currVal_4);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,9).target;
        const currVal_1:any = i1.ɵnov(_v,9).href;
        _ck(_v,8,0,currVal_0,currVal_1);
      });
}
export function View_LoginComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),85,'form',[['class',
      'auth-page'],['ngNativeValidate','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'ngSubmit'],[(null as any),'submit'],[(null as any),
      'reset']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i10.LoginComponent = _v.component;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,1).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    if (('ngSubmit' === en)) {
      const pd_2:any = ((<any>_co.login()) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i11.NgForm,[[8,(null as any)],
      [8,(null as any)]],(null as any),{ngSubmit:'ngSubmit'}),i1.ɵprd(2048,(null as any),
      i11.ControlContainer,(null as any),[i11.NgForm]),i1.ɵdid(16384,(null as any),
      0,i11.NgControlStatusGroup,[i11.ControlContainer],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          79,'div',[['class','many-inputs auth-panel']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'loading-indicator',
          [['class','overlay']],(null as any),(null as any),(null as any),i12.View_LoadingIndicatorComponent_0,
          i12.RenderType_LoadingIndicatorComponent)),i1.ɵdid(573440,(null as any),
          0,i13.LoadingIndicatorComponent,[i1.ElementRef],{isVisible:[0,'isVisible']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),3,'a',[['class','logo']],[[1,'target',
              0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,11).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i9.RouterLinkWithHref,
          [i9.Router,i9.ActivatedRoute,i8.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          0,'img',[['alt','logo']],[[8,'src',4]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoginComponent_1)),
      i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),15,'div',[['class','input-container']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),0,'label',[['class','hidden'],['for','email']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'input',
          [['id','email'],['name','email'],['placeholder','Email'],['required',''],
              ['type','email']],[[1,'required',0],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.LoginComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,23)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,23).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,23)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,23)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>(_co.model.email = $event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i11.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i11.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i11.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i11.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i11.RequiredValidator]),i1.ɵprd(1024,(null as any),i11.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i11.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i11.NgModel,
          [[2,i11.ControlContainer],[2,i11.NG_VALIDATORS],[8,(null as any)],[2,i11.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i11.NgControl,(null as any),[i11.NgModel]),i1.ɵdid(16384,(null as any),
          0,i11.NgControlStatus,[i11.NgControl],(null as any),(null as any)),(_l()(),
          i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_LoginComponent_2)),i1.ɵdid(16384,(null as any),
          0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),21,'div',
          [['class','input-container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),0,'label',[['class','hidden'],
          ['for','password']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),7,'input',[['id','password'],['name',
              'password'],['placeholder','Password'],['required',''],['type','password']],
              [[1,'required',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
                  [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,
                      'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,
                      'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
                  [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
                  [(null as any),'compositionend']],(_v,en,$event) => {
                var ad:boolean = true;
                var _co:i10.LoginComponent = _v.component;
                if (('input' === en)) {
                  const pd_0:any = ((<any>i1.ɵnov(_v,40)._handleInput($event.target.value)) !== false);
                  ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                  const pd_1:any = ((<any>i1.ɵnov(_v,40).onTouched()) !== false);
                  ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                  const pd_2:any = ((<any>i1.ɵnov(_v,40)._compositionStart()) !== false);
                  ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                  const pd_3:any = ((<any>i1.ɵnov(_v,40)._compositionEnd($event.target.value)) !== false);
                  ad = (pd_3 && ad);
                }
                if (('ngModelChange' === en)) {
                  const pd_4:any = ((<any>(_co.model.password = $event)) !== false);
                  ad = (pd_4 && ad);
                }
                return ad;
              },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i11.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i11.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i11.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i11.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i11.RequiredValidator]),i1.ɵprd(1024,(null as any),i11.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i11.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i11.NgModel,
          [[2,i11.ControlContainer],[2,i11.NG_VALIDATORS],[8,(null as any)],[2,i11.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i11.NgControl,(null as any),[i11.NgModel]),i1.ɵdid(16384,(null as any),
          0,i11.NgControlStatus,[i11.NgControl],(null as any),(null as any)),(_l()(),
          i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),4,'a',[['class','forgot-password'],['trans','']],[[1,'target',
              0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,49).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i9.RouterLinkWithHref,
          [i9.Router,i9.ActivatedRoute,i8.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),i1.ɵdid(4341760,(null as any),0,i4.TranslateDirective,
          [i1.ElementRef,i5.Translations,i6.SettingsService],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['Forgot?'])),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoginComponent_3)),
      i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),22,'div',[['class','remember-and-login-row']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',
          [['class','remember-me-checkbox']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),5,'input',[['class','pretty-checkbox'],
          ['id','remember'],['name','remember'],['type','checkbox']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
          [(null as any),'change'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i10.LoginComponent = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,63).onChange($event.target.checked)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,63).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.model.remember = $event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i11.CheckboxControlValueAccessor,
          [i1.Renderer2,i1.ElementRef],(null as any),(null as any)),i1.ɵprd(1024,(null as any),
          i11.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i11.CheckboxControlValueAccessor]),i1.ɵdid(671744,(null as any),0,i11.NgModel,
          [[2,i11.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i11.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i11.NgControl,(null as any),[i11.NgModel]),i1.ɵdid(16384,(null as any),
          0,i11.NgControlStatus,[i11.NgControl],(null as any),(null as any)),(_l()(),
          i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),2,'label',[['for','remember'],['trans','']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(4341760,
          (null as any),0,i4.TranslateDirective,[i1.ElementRef,i5.Translations,i6.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['Remember Me'])),
      (_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵted((null as any),
          ['\n\n            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'div',
          [['class','login-button']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),2,'button',[['class','button primary submit-button'],
              ['trans',''],['type','submit']],(null as any),(null as any),(null as any),
              (null as any),(null as any))),i1.ɵdid(4341760,(null as any),0,i4.TranslateDirective,
          [i1.ElementRef,i5.Translations,i6.SettingsService],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['Login'])),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_LoginComponent_4)),i1.ɵdid(16384,(null as any),0,i8.NgIf,
          [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),['\n'])),
      (_l()(),i1.ɵted((null as any),['\n\n']))],(_ck,_v) => {
    var _co:i10.LoginComponent = _v.component;
    const currVal_7:any = _co.isLoading;
    _ck(_v,8,0,currVal_7);
    const currVal_10:any = _ck(_v,12,0,'/');
    _ck(_v,11,0,currVal_10);
    const currVal_12:any = _co.errors.general;
    _ck(_v,16,0,currVal_12);
    const currVal_21:any = '';
    _ck(_v,24,0,currVal_21);
    const currVal_22:any = 'email';
    const currVal_23:any = _co.model.email;
    _ck(_v,27,0,currVal_22,currVal_23);
    const currVal_24:any = _co.errors.email;
    _ck(_v,32,0,currVal_24);
    const currVal_33:any = '';
    _ck(_v,41,0,currVal_33);
    const currVal_34:any = 'password';
    const currVal_35:any = _co.model.password;
    _ck(_v,44,0,currVal_34,currVal_35);
    const currVal_38:any = _ck(_v,50,0,'/forgot-password');
    _ck(_v,49,0,currVal_38);
    const currVal_39:any = _co.errors.password;
    _ck(_v,55,0,currVal_39);
    const currVal_47:any = 'remember';
    const currVal_48:any = _co.model.remember;
    _ck(_v,65,0,currVal_47,currVal_48);
    const currVal_49:boolean = !_co.settings.get('registration.disable');
    _ck(_v,83,0,currVal_49);
  },(_ck,_v) => {
    var _co:i10.LoginComponent = _v.component;
    const currVal_0:any = i1.ɵnov(_v,3).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,3).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,3).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,3).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,3).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,3).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,3).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = i1.ɵnov(_v,11).target;
    const currVal_9:any = i1.ɵnov(_v,11).href;
    _ck(_v,10,0,currVal_8,currVal_9);
    const currVal_11:any = _co.settings.get('branding.site_logo');
    _ck(_v,13,0,currVal_11);
    const currVal_13:any = (i1.ɵnov(_v,24).required? '': (null as any));
    const currVal_14:any = i1.ɵnov(_v,29).ngClassUntouched;
    const currVal_15:any = i1.ɵnov(_v,29).ngClassTouched;
    const currVal_16:any = i1.ɵnov(_v,29).ngClassPristine;
    const currVal_17:any = i1.ɵnov(_v,29).ngClassDirty;
    const currVal_18:any = i1.ɵnov(_v,29).ngClassValid;
    const currVal_19:any = i1.ɵnov(_v,29).ngClassInvalid;
    const currVal_20:any = i1.ɵnov(_v,29).ngClassPending;
    _ck(_v,22,0,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,
        currVal_19,currVal_20);
    const currVal_25:any = (i1.ɵnov(_v,41).required? '': (null as any));
    const currVal_26:any = i1.ɵnov(_v,46).ngClassUntouched;
    const currVal_27:any = i1.ɵnov(_v,46).ngClassTouched;
    const currVal_28:any = i1.ɵnov(_v,46).ngClassPristine;
    const currVal_29:any = i1.ɵnov(_v,46).ngClassDirty;
    const currVal_30:any = i1.ɵnov(_v,46).ngClassValid;
    const currVal_31:any = i1.ɵnov(_v,46).ngClassInvalid;
    const currVal_32:any = i1.ɵnov(_v,46).ngClassPending;
    _ck(_v,39,0,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,
        currVal_31,currVal_32);
    const currVal_36:any = i1.ɵnov(_v,49).target;
    const currVal_37:any = i1.ɵnov(_v,49).href;
    _ck(_v,48,0,currVal_36,currVal_37);
    const currVal_40:any = i1.ɵnov(_v,67).ngClassUntouched;
    const currVal_41:any = i1.ɵnov(_v,67).ngClassTouched;
    const currVal_42:any = i1.ɵnov(_v,67).ngClassPristine;
    const currVal_43:any = i1.ɵnov(_v,67).ngClassDirty;
    const currVal_44:any = i1.ɵnov(_v,67).ngClassValid;
    const currVal_45:any = i1.ɵnov(_v,67).ngClassInvalid;
    const currVal_46:any = i1.ɵnov(_v,67).ngClassPending;
    _ck(_v,62,0,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44,currVal_45,
        currVal_46);
  });
}
export function View_LoginComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'login',([] as any[]),
      (null as any),(null as any),(null as any),View_LoginComponent_0,RenderType_LoginComponent)),
      i1.ɵprd(512,(null as any),i14.AuthService,i14.AuthService,[i15.HttpClient,i16.CurrentUser,
          i9.Router,i9.ActivatedRoute,i17.ToastService,i1.NgZone,i18.ModalService]),
      i1.ɵdid(49152,(null as any),0,i10.LoginComponent,[i14.AuthService,i19.SocialAuthService,
          i6.SettingsService,i9.Router,i16.CurrentUser],(null as any),(null as any))],
      (null as any),(null as any));
}
export const LoginComponentNgFactory:i1.ComponentFactory<i10.LoginComponent> = i1.ɵccf('login',
    i10.LoginComponent,View_LoginComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/auth/login/login.component.ngfactory.ts